module.exports = __webpack_public_path__ + "img/green.dbb07bd6.svg";